import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../../services/validation-service/validation.service";
import {BehaviorSubject} from "rxjs";
import {Suburb} from "../../../../model/Suburb";
import {SearchSuburbResponse} from "../../../../model/SearchSuburbResponse";
import {isNullOrUndefined} from "util";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {ErrorMessages} from "../../../../model/ErrorMessages";
import {SelectListItem} from "../../../../model/SelectListItem";
import {LeadService} from "../../../../services/lead-service/lead.service";
import {WebLeadType} from "../../../../model/leads/WebLeadType";
import {GtmService} from '../../../../services/gtm-service/gtm.service';

declare var $: any;
declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-parking-questions',
  templateUrl: './parking-questions.component.html'
})
export class ParkingQuestionsComponent implements OnInit {

  suburbSearchTerm: BehaviorSubject<string> = new BehaviorSubject<string>('');
  suburbList: BehaviorSubject<Suburb[]> = new BehaviorSubject<Suburb[]>([]);
  suburbSearched = false;
  errorMessage = ErrorMessages;
  loadingSuburbs = false;

  constructor(public router: Router,
              public quotationService: QuotationService,
              public leadService: LeadService,
              public validationService: ValidationService,
              private gtmService: GtmService) { }

  ngOnInit() {
    this.suburbSearchTerm.pipe(debounceTime(500),
      distinctUntilChanged()).subscribe(term => {
      this.addressAutocomplete(term);
    });
    this.reloadJCF();
  }

  get vehicleDescription(): String {
    let vehicle = this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.itemDescription;
    vehicle = vehicle.substr(0, vehicle.length-12);
    if (vehicle.substr(vehicle.length-4, vehicle.length).match(/\d+/g)) {
      vehicle = vehicle.substr(0, vehicle.length-4)
    }
    return vehicle;
  };

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  suburbInputChange(value: any) {
    this.suburbSearchTerm.next(value);
  }

  public addressAutocomplete(phrase: string): void {
    if (phrase.length >= 4) {
      this.loadingSuburbs = true;
      // clean any special chars from the input
      phrase = phrase.replace(/[^a-zA-Z\-\'\s\,]/g, '');
      this.quotationService.searchSuburb(phrase).subscribe((response: SearchSuburbResponse) => {
        this.suburbSearched = true;
        this.loadingSuburbs = false;
        this.suburbList.next(response.suburbLookupList);
      }, error => {
        this.quotationService.error = true;
        this.loadingSuburbs = false;
      });
    }
  }

  public selectAddress(suburb: Suburb, fieldName: string, fieldValue: string) {
    this.fireAbandonmentTrackingEvent(fieldValue, fieldName);
    if (!isNullOrUndefined(suburb)) {
      this.loadingSuburbs = false;
      this.quotationService.quotationRequest.suburb = suburb;
      this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.suburbCd = suburb.suburbCd;
      this.validationService.addressCheckValue = suburb.description;
      this.updateLead();
    }
    this.suburbList.next([]);
  }

  public setSecurityDescription(securityType: SelectListItem) {
    this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.addressSecurityDescr = securityType.label;
  }

  updateLead() {
    const readyToUpdateLead = this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.suburbCd &&
      this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.addressSecurityCd &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.planHolder != null;

    if (readyToUpdateLead) {
      if (!this.leadService.leadComment.toLowerCase().includes('parking address')) {
        const securityDescription = this.quotationService.parkingSecuritySelectItemList.find(item =>
          item.key === this.quotationService.getQuoteVehicleAndDriverDetails.vehicle.nightTimeAddress.addressSecurityCd.toString()).label;
        this.leadService.leadComment += '|Parking address:' + this.quotationService.quotationRequest.suburb.description
          + '|Security:' + securityDescription;
        this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
      }
    }

  }

  fireAbandonmentTrackingEvent(fieldValue: string, fieldName: string) {
    if (fieldValue && !this._isAbandonmentTrackingFired(fieldName)) {
      this.gtmService.formName = 'insure_60_second_quote';
      this.gtmService.postGtmEvent('form_abandoned', fieldName, 2);
      this._setTrackingFiredOnField(fieldName);
    }

  }

  private _setTrackingFiredOnField(fieldName: string) {
    switch (fieldName) {
      case 'suburb' : {
        this.gtmService.suburbAbandonmentTrackingFired = true;
        break;
      }
      case 'security' : {
        this.gtmService.selectSecurityAbandonmentTrackingFired = true;
        break;
      }
    }
  }

  private _isAbandonmentTrackingFired(fieldName: string): boolean {
    switch (fieldName) {
      case 'suburb' : return this.gtmService.suburbAbandonmentTrackingFired;
      case 'security' : return this.gtmService.selectSecurityAbandonmentTrackingFired;
    }
  }

}

